import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  Chip,
  Container,
  useMediaQuery,
} from '@mui/material';
import * as actions from "../../../../store/actions";
import { i18n } from '../../../../translate/i18n';
import Spinner from '../../../../components/Spinner/index';
import Tabs from '../../../../components/Tabs/TabsEquipment';
import Timeline from '../../../../components/ActionsTimeline/index';
import { RouteComponentProps } from 'react-router-dom';
import { RootState } from '../../../../store/types';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    minHeight: '10rem',
    alignItems: 'center',
    flexDirection: 'column' as any,
  },
  servicesContainer: {
    marginTop: '0.5rem',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.75rem 0.5rem'
  },
  title: {
    fontSize: '0.9rem',
  },
  subtitle: {
    fontSize: '0.7rem',
  },
  chipContainer: {
    padding: '0.5rem 0 0 0',
    display: 'flex',
    alignItems: 'flex-start',
    marginLeft: '4.5rem'
  },
  chip: {
    cursor: 'pointer',
    margin: '0.1rem',
  },
  actionsNotFound: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '1rem 0',
  },
  mainContent: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column' as any,
    justifyContent: 'center',
  },
  loadMoreBox: {
    display: 'flex',
    alignSelf: 'center',
    marginTop: '1rem',
  }
};

interface RouteParams {
  id: string
}

interface Props extends RouteComponentProps<RouteParams> {
}

const FormEquipmentsActions: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const equipId = props.match.params.id;
  const matches = useMediaQuery('(min-width:1200px)');

  const fetchActionsByEquipment = (shouldFetchMoreData = false) => {
   return dispatch(actions.fetchActionsByEquipment(equipId, page, limit, selectedStatus, shouldFetchMoreData));    
  }

  const timelineActions = useSelector((state: RootState) => state.equipments.timelineActions);
  const loadingActions = useSelector((state: RootState) => state.equipments.timelineActionsLoading);
  const loadingMoreActions = useSelector((state: RootState) => state.equipments.timelineActionsLoadingMoreData);
  const actionsCount = useSelector((state: RootState) => state.equipments.timelineActionsCount);

  const [page, setPage] = useState<number>(1);
	const [limit] = useState<number>(10);
  const [selectedStatus, setSelectedStatus] = useState<string[]>([]);

  const actionStatus = [
    {
      value: 'progress',
      label: i18n.t('statusActionModalFilter.progress')
    },
    {
      value: 'overdue',
      label: i18n.t('statusActionModalFilter.overdue')
    },
    {
      value: 'canceled',
      label: i18n.t('statusActionModalFilter.canceled')
    },
    {
      value: 'completed',
      label: i18n.t('statusActionModalFilter.completed')
    }
  ];

  useEffect(() => {
    fetchActionsByEquipment();
  }, [equipId, selectedStatus]);

  useEffect(() => {
    if (page > 1) fetchActionsByEquipment(true);
  }, [page]);

  const handleClickAction = (actionId: string) => {
    props.history.push(`/form-action/${actionId}`);
  };

  const handleClickFilterChip = (status: string) => {
    setSelectedStatus(prevState => {
      setPage(1);
      if (prevState.indexOf(status) === -1) {
        return ([...prevState, status]);
      }
      return prevState.filter(i => i !== status);
    })
  }

  const loadMore = () => {
    setPage(prev => prev + 1);
  }

  return (
    <>
      <Tabs {...props} selected={'actionsTab'} />
        <Box style={styles.chipContainer}>
          {actionStatus.map(status => (
            <Chip
              key={status.value}
              onClick={() => handleClickFilterChip(status.value)}
              clickable
              variant="outlined"
              label={status.label}
              style={{
                ...styles.chip,
                backgroundColor: selectedStatus.indexOf(status.value) === -1 ? '#fff' : '#ccc',
              }}
            />
          ))}
        </Box>
        <Container maxWidth='md' style={styles.container}>
          {loadingActions && <Spinner overlay size={30}/>}
          {!loadingActions && timelineActions && timelineActions.length === 0 &&
            <Box style={styles.actionsNotFound}>{i18n.t('formEquipmentActions.notFoundActions') as string}</Box>}
          {!loadingActions && timelineActions.length > 0 &&
            <Box style={styles.mainContent}>
              <Timeline data={timelineActions} spinner={loadingActions} handleAction={handleClickAction} />
              {!loadingActions && 
                <Box style={styles.loadMoreBox}>
                  { loadingMoreActions && <Spinner size={30} overlay={false}/> }
                  {!loadingActions && !loadingMoreActions && timelineActions.length < actionsCount &&
                    <Button onClick={() => loadMore()} variant='outlined'>
                      { i18n.t('formEquipmentActions.loadMoreButtonText') as string }
                    </Button>}
                </Box>
              }
            </Box>          
          }
        </Container>
    </>
  )
}

export default FormEquipmentsActions;
